import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const fastmail = defineConnector({
  identifier: "fastmail",
  name: "FastMail",
  tagLine: "Email hosting and productivity",
  logo,
  protocol: "http",
  tags: ["communication", "productivity"],
  defaultUrlPattern: () => "https://api\\.fastmail\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [FastMail Settings > Privacy & Security > API tokens](https://app.fastmail.com/settings/security/tokens) and create a new API token.",
        },
      ],
    },
    {
      title: "Copy and paste the API token into the field below",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.fastmail.com/jmap/session",
  },
});
